import apiClient from '@data/apiClient';
import { getLmsLink } from '@utils/edxLinks';
import {
  ENROLL_SUBMISSION_ERROR,
  ENROLL_SUBMISSION_SUCCESS,
} from '@data/constants/actionTypes/enrollment';

export const enrollSubmissionError = error => ({
  type: ENROLL_SUBMISSION_ERROR,
  error,
});

export const enrollSubmissionSuccess = value => ({
  type: ENROLL_SUBMISSION_SUCCESS,
  value,
});

export const enrollUser = data => (dispatch) => {
  apiClient.post(
    getLmsLink(process.env.GATSBY_COURSE_RUN_ENROLLMENT_API),
    JSON.stringify(data),
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      withCredentials: true,
    },
  ).then((response) => {
    if (response.ok || response.status === 200) {
      return dispatch(enrollSubmissionSuccess(response));
    }
    const error = new Error(response.statusText);
    error.response = response;

    return dispatch(enrollSubmissionError(error));
  }).catch(error => dispatch(enrollSubmissionError(error)));
};
